import { HttpClient } from '@opallabs/api'
import removeAnnotation from '../removeAnnotation'

const deleteAnnotation = ({ annotationId }) =>
  HttpClient().delete(`/annotation/v1/${annotationId}`)

const destroyAnnotation = (options) => (dispatch) =>
  deleteAnnotation(options)
    .then((response) => {
      if (response.status === 200) {
        dispatch(removeAnnotation(options.annotationId))
      }

      return {}
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default destroyAnnotation
